/** Custom Columns + grid keys for Sales Order Details (date-range / ST Reports table). */
export var SALES_ORDER_DETAILS_COLUMN_KEYS = [
    "orderNumber",
    "customerName",
    "orderDate",
    "orderPaidDate",
    "subtotal",
    "commission",
    "companyName",
    "companyLocation",
    "salesMethod",
    "fulfilmentStatus",
    "status",
];
export var SALES_ORDER_DETAILS_COLUMN_DEFS = [
    { key: "orderNumber", labelKey: "myOrders_table1Column1" },
    { key: "customerName", labelKey: "draftOrder_CustName" },
    { key: "orderDate", labelKey: "stReports_col_orderDate" },
    { key: "orderPaidDate", labelKey: "yourSales_PaidOrders_PaidDate" },
    { key: "subtotal", labelKey: "team_column5" },
    { key: "commission", labelKey: "yourSales_table1Column5" },
    { key: "companyName", labelKey: "draftOrder_CompanyName", b2bOnly: true },
    { key: "companyLocation", labelKey: "dashboard_B2BCompanyLocation", b2bOnly: true },
    { key: "salesMethod", labelKey: "team_column8" },
    { key: "fulfilmentStatus", labelKey: "stReports_col_fulfilmentStatus" },
    { key: "status", labelKey: "stReports_col_orderStatus" },
];
/** Default: every applicable column visible on first load. */
export function createDefaultSalesOrderDetailsColumnVisibility(isB2BShop) {
    var visibility = {};
    for (var _i = 0, SALES_ORDER_DETAILS_COLUMN_DEFS_1 = SALES_ORDER_DETAILS_COLUMN_DEFS; _i < SALES_ORDER_DETAILS_COLUMN_DEFS_1.length; _i++) {
        var col = SALES_ORDER_DETAILS_COLUMN_DEFS_1[_i];
        if (col.b2bOnly && !isB2BShop) {
            continue;
        }
        visibility[col.key] = true;
    }
    return visibility;
}
export function isSalesOrderDetailsColumnVisible(columnVisibility, key) {
    return (columnVisibility === null || columnVisibility === void 0 ? void 0 : columnVisibility[key]) !== false;
}
export function getSalesOrderDetailsColumnsForShop(isB2BShop) {
    return SALES_ORDER_DETAILS_COLUMN_DEFS.filter(function (col) { return !col.b2bOnly || isB2BShop; });
}
